import { TravelMap } from "./single-travel/TravelMap.js";
import DepartureGallery from "./single-travel/departure-single-gallery.js";
import expandableItem from "./single-travel/expandableItem.js";
import stickyInfo from "./single-travel/stickyInfo.js";

import "../scss/pages/single-travel.scss";

addEventListener("DOMContentLoaded", (event) => {
	expandableItem();
	stickyInfo();
	TravelMap();

	const gallery = new DepartureGallery(
		"layoutGallery",
		"layoutGallery__image"
	);
	gallery.init();
});
